module.exports = __webpack_public_path__ + "static/media/sugar.e034e258.png";